import { render, staticRenderFns } from "./PlayerBalance.vue?vue&type=template&id=3060cf60&scoped=true"
import script from "./PlayerBalance.vue?vue&type=script&lang=js"
export * from "./PlayerBalance.vue?vue&type=script&lang=js"
import style0 from "./PlayerBalance.vue?vue&type=style&index=0&id=3060cf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060cf60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
